import { useState, useEffect } from 'react'
import {
  HeroContainer,
  HeroBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroSpan
} from './HeroElems'
// import 'css-doodle'

export default function HeroSection() {
    const str = "Hey there! I'm"
    const [typedStr, setTypedStr] = useState('')
    useEffect(() => {
      if (typedStr === str) return;
      const timeout = setTimeout(() => {
        setTypedStr(str.slice(0, typedStr.length + 1))
      }, 110)

      return () => clearTimeout(timeout)
    })
  
    return (
      <HeroContainer id='home'>
        <HeroBg>
        </HeroBg>
        <HeroContent>
          <HeroH1>{typedStr}<HeroSpan> <span>&#123;</span> Tyler Gan <span>&#125;</span></HeroSpan></HeroH1>
          <HeroP>
            Aspiring in Finance and Computer Science
          </HeroP>
        </HeroContent>
      </HeroContainer>
    )
  }
  